'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('react');
var ErrorBoundaryContext = require('./ErrorBoundaryContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

class ErrorBoundary extends react.Component {
  constructor() {
    super(...arguments);
    // dx is better when this is uncommented but it causes babel to error during build
    // declare context: React.ContextType<typeof ErrorBoundaryContext>;
    _defineProperty__default["default"](this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    // This lint error can be fixed once the above declare context issues can be resolved with babel
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.context.handleError(error);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children,
      errorContent
    } = this.props;
    return hasError ? errorContent : children;
  }
}
_defineProperty__default["default"](ErrorBoundary, "contextType", ErrorBoundaryContext.ErrorBoundaryContext);

exports.ErrorBoundaryProvider = ErrorBoundaryContext.ErrorBoundaryProvider;
exports["default"] = ErrorBoundary;
